<template>
  <div class="uebersicht">
    <div class="columns">
      <div class="column" style="text-align:left;">
          <router-link style="min-width:180px" class="button is-primary" to="/producer">Neuer Hersteller</router-link>
      </div>
      <div class="column">

      </div>
      <div class="column">

      </div>
      <div class="column">
        <b-field>
            <b-input placeholder="Suche..."
                type="search"
                icon="magnify"
                 v-model="search">
            </b-input>
        </b-field>
      </div>
    </div>
    <b-table :data="data" :loading="loading" checkable hoverable>
      <template slot-scope="props">
        <b-table-column field="id" label="ID" sortable>
            {{ props.row.id }}
        </b-table-column>
				<b-table-column field="name" label="Name" sortable>
            {{ props.row.name }}
        </b-table-column>
        <b-table-column  field="code" label="Code" sortable>
            {{ props.row.code}}
        </b-table-column>
      <b-table-column width="115" custom-key="actions">
        <button  style="border:0px;margin-right:7px;" class="button is-small" @click="editItem(props.row)">
        <b-icon type="is-primary" icon="pencil"></b-icon>
        </button>
        <!--<button  style="border:0px;margin-right:7px;" class="button is-small" @click="copyItem(props.row)">
        <b-icon type="is-primary" icon="content-copy"></b-icon>
      </button>-->
         <button style="border:0px;" class="button is-small" @click="deleteItem(props.row)">
        <b-icon type="is-danger" icon="delete"></b-icon>
        </button>
      </b-table-column>
    </template>

    <!--<template slot="detail" slot-scope="props">
      <tabledetail :row="props.row"></tabledetail>
    </template>-->

    <template slot="empty">
              <section class="section">
                  <div class="content has-text-grey has-text-centered">
                      <p>
                          <b-icon
                              icon="emoticon-sad"
                              size="is-large">
                          </b-icon>
                      </p>
                      <p>Keine Hersteller gefunden.</p>
                  </div>
              </section>
          </template>

      </b-table>
    </b-table>
  </div>
</template>

<script>
// @ is an alias to /src

const axios = require('axios');

export default {
  name: "producer",
  components: {
  //  HelloWorld
},
data() {
      return {
          search: "",
          loading: true,
          data: [],
          allData: [] //Für Suchfunktion nötig
      }
  },
  watch: {
    search: function(val) {
      console.log("Suche");
      console.log(val);
      console.log(this.allData);
      val = val.toLowerCase();

      this.data =  _.filter(this.allData, function(obj) {
        var name = obj.name;
        name = name.toLowerCase();
        if (name.indexOf(val) >= 0) {
         return true;
        }
      });
    },
  },
  mounted: function () {
    this.loadItems();
  },
  methods: {
    loadItems: function() {
      var _this = this;
      _this.loading = true;
      axios.get('/api/producers', {
        withCredentials: true,
      })
      .then(function (response) {
        console.log(response.data);
        _this.data = response.data;
        _this.allData = response.data;
        _this.loading = false;
      })
      .catch(function (error) {
        console.log(error);
          _this.loading = false;
      })
      .then(function () {
        // always executed
      });

    },
    deleteItem: function(item) {
      console.log("DELETE "+item.id);
      var vm = this;
      this.$buefy.dialog.confirm({
        title: 'Hersteller löschen',
        message: 'Soll der Hersteller "'+ item.name +'" wirklich gelöscht werden?',
        confirmText: 'Hersteller löschen',
        type: 'is-danger',
        hasIcon: true,
        cancelText: 'Abbrechen',
        onConfirm: function() {
             console.log(vm.search);
             axios.delete('/api/producers/'+item.id, {
               withCredentials: true,
             })
             .then(function (response) {
               console.log(response.data);
                vm.$buefy.toast.open('Der Hersteller wurde gelöscht!');
                vm.loadItems();
             })
             .catch(function (error) {

             })
             .then(function () {
               // always executed
             });

            }

       })
    },
    copyItem: function(item) {
      console.log("COPY "+item.id);
    },
    editItem: function(item) {
      console.log("EDIT "+item.id);
      this.$router.push({ name: 'editproducer', params: { id: item.id } })
    }
  }
};
</script>
